import { render, staticRenderFns } from "./AuctionAdmin.vue?vue&type=template&id=0a75a90a&scoped=true&lang=pug"
import script from "./AuctionAdmin.vue?vue&type=script&lang=ts"
export * from "./AuctionAdmin.vue?vue&type=script&lang=ts"
import style0 from "./AuctionAdmin.vue?vue&type=style&index=0&id=0a75a90a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a75a90a",
  null
  
)

export default component.exports